import Training from '../../training';

/**
 * Create the action
 */

const { thunk, request, success, error } = Training.store((data, fetch) => {
    if (data.cloneFromId) {
        const editable = data.editable ? 'editable=1' : '';
        return fetch.get(`/trainings/${data.cloneFromId}/clone?${editable}`);
    }

    // Prepare request
    let formData = new FormData();
    ['visibility', 'title', 'description', 'youtube', 'is_published']
        .map(key => data[key] !== undefined ? formData.append(key, data[key]) : null);
    
    return fetch.post(`/trainings`, formData);
});

/**
 * Export the components
 */

export { thunk as default };
export { request, success, error };
